module.exports = __webpack_public_path__ + "static/media/x-one-tires.3cbbe9f9.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/dealerFeatures/x-one-tires.svg
// module id = 2543
// module chunks = 2